export const MODAL_NAME = 'LoanCoverModal'

export const CLOSE_CHECK_MODAL = 'LoanCloseCheckModal'
